export default {
  palette: [],
  seo: {
    title: 'Lorem ipsum',
    link: 'www.lorem.com',
    description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Modi placeat incidunt animi.',
    ogImageUrl: '',
  },
  javascript: {
    head: '',
    body: '',
  },
}
